import translate from './doctor-or-condition-selector.language';

class DoctorOrConditionSelectorController {
	constructor() {
		this.translate = translate;
	}
	/**
	 * Initialization state props
	 */
	$onInit() {
		if(!this.searchFields) this.searchFields = ['name'];

		if(!this.doctorOrConditionList) this.doctorOrConditionList = [];

		if(!this.minCharacter) this.minCharacter = 1;

		if(!this.activateOnFocus) this.activateOnFocus = false;

		if(!this.displayField) this.displayField = "name";
	}

	resetDoctorOrConditionList(){
		if (angular.isFunction(this.onSelect))
			this.onSelect({
				$event: {
					value:null
				}
			});
	}
	
	/*
     * Change selected doctor or condition
     */
	setSelectedDoctorOrCondition({value}) {
		if (angular.isFunction(this.onSelect))
			this.onSelect({
				$event: {
					value
				}
			});
	}
}

export default DoctorOrConditionSelectorController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-or-condition-selector/doctor-or-condition-selector.controller.js